import { render, staticRenderFns } from "./IndexPlanificaciones.vue?vue&type=template&id=0fad39fd"
import script from "./IndexPlanificaciones.vue?vue&type=script&lang=js"
export * from "./IndexPlanificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports